import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVisionProApp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVisionProApp"><Path d="M0.5 8.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 17.5H22.5V4.5H2.5L2.5 17.5H5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 19.5V16.6428H19.5V19.5H5.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVisionProApp;
